export default class Tag {
	constructor({
		id,
		label,
		organization,
		event,
	}) {
		this._id = id;
		this._label = label;
		this._organization = organization;
		this._event = event;
	}

	getId = () => this._id;

	getKey = () => String(this._id);

	getLabel = () => this._label;

	getOrganization = () => this._organization;

	getPosition = () => this._event;
}
